module.exports = __webpack_public_path__ + "static/media/a8.a78e3d7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sijie/a8.mp3
// module id = NWvl
// module chunks = 0